export interface CatalogItemCreatePrefill {
    name: string;
    description: string;
    classIds: string[];
    revenueAccountId: string | null;
    receivablesAccountId: string | null;
    unitAmount: number | null;
    currency: string;
}

interface BuildCatalogItemCreatePrefillParams {
    typedName: string;
    productOrService: string;
    description: string;
    unitAmount: number | null;
    classIds: string[];
    accrualAccountId: string | null;
    receivablesAccountId: string | null;
    currency: string;
}

export function buildCatalogItemCreatePrefill({
    typedName,
    productOrService,
    description,
    unitAmount,
    classIds,
    accrualAccountId,
    receivablesAccountId,
    currency,
}: BuildCatalogItemCreatePrefillParams): CatalogItemCreatePrefill {
    const trimmedTypedName = typedName.trim();
    const trimmedProduct = productOrService.trim();
    const trimmedDescription = description.trim();
    const name = trimmedTypedName || trimmedProduct || trimmedDescription;

    return {
        name,
        description: trimmedDescription,
        classIds,
        revenueAccountId: accrualAccountId,
        receivablesAccountId,
        unitAmount:
            unitAmount != null &&
            Number.isFinite(unitAmount) &&
            unitAmount !== 0
                ? unitAmount
                : null,
        currency: currency.trim().toLowerCase() || "usd",
    };
}
